import React from "react";
import { Button, Row, Col } from "react-bootstrap";
import DataTable from "../Components/Datatable";
import { columns, data } from "../Components/data";

const ExMembers = () => {
  return (
    <section className="p-3 mx-md-5 mt-md-5 ">
      <h1>Ex Members of Bar Association Dehardun</h1>
      <br />
      <div className="mt-md-5">
        <DataTable columns={columns} data={data} />
      </div>
    </section>
  );
};

export default ExMembers;
